// extracted by mini-css-extract-plugin
export default {"date":"I_kVM1","location":"yT3PPL"};